<template>
    <div class="mine-page">
        <!-- 用户卡 -->
        <header class="mine-hero">
            <div class="mine-avatar">{{ avatarText }}</div>
            <div class="mine-name">{{ displayName }}</div>
            <div class="mine-sub">{{ subTitle }}</div>
        </header>

        <main class="mine-body">
            <!-- 常用 -->
            <section class="mine-card">
                <div
                    class="mine-row"
                    v-for="item in entries"
                    :key="item.text"
                    @click="handleGo(item.path)"
                >
                    <span class="row-ico" v-html="item.icon"></span>
                    <span class="row-text">{{ item.text }}</span>
                    <span class="row-tip">{{ item.tip }}</span>
                    <span class="row-arrow">›</span>
                </div>
            </section>

            <!-- 关于 -->
            <section class="mine-card">
                <div class="mine-row" @click="showAbout = true">
                    <span class="row-ico" v-html="ICONS.info"></span>
                    <span class="row-text">关于</span>
                    <span class="row-tip">v{{ version }}</span>
                    <span class="row-arrow">›</span>
                </div>
            </section>

            <p class="mine-foot">© 版权所有 鄂ICP备2020017212号-1</p>
        </main>

        <!-- 关于 -->
        <div class="about-mask" v-if="showAbout" @click.self="showAbout = false">
            <div class="about-box">
                <p class="about-title">简录学业</p>
                <p class="about-ver">v{{ version }}</p>
                <p class="about-text">学习记录 · 成绩曲线 · 信箱</p>
                <p class="about-text">© 鄂ICP备2020017212号-1</p>
                <button class="about-btn" @click="showAbout = false">知道了</button>
            </div>
        </div>
    </div>
</template>

<script>
const ICONS = {
    letter:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<rect x="3" y="5.4" width="18" height="13.2" rx="2.4"/><path d="m3.8 7.4 8.2 5.8 8.2-5.8"/></svg>',
    chart:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M4 4v16h16"/><path d="m7 15.4 3.6-4.2 3 2.6 4.4-5.6"/></svg>',
    list:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M8.4 7h11M8.4 12h11M8.4 17h11"/><circle cx="4.6" cy="7" r="1.1" fill="currentColor" stroke="none"/>' +
        '<circle cx="4.6" cy="12" r="1.1" fill="currentColor" stroke="none"/><circle cx="4.6" cy="17" r="1.1" fill="currentColor" stroke="none"/></svg>',
    game:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M7.6 7h8.8a4.4 4.4 0 0 1 4.4 4.4v0a4.4 4.4 0 0 1-4.4 4.4h-1.6L13 18.4h-2l-1.8-2.6H7.6A4.4 4.4 0 0 1 3.2 11.4v0A4.4 4.4 0 0 1 7.6 7Z"/>' +
        '<path d="M7 10.4v2M6 11.4h2"/><circle cx="16.2" cy="10.6" r=".9" fill="currentColor" stroke="none"/><circle cx="17.8" cy="12.4" r=".9" fill="currentColor" stroke="none"/></svg>',
    info:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="12" cy="12" r="8.8"/><path d="M12 11v5.6"/><circle cx="12" cy="7.9" r="1.05" fill="currentColor" stroke="none"/></svg>'
};

export default {
    name: 'AppMine',
    data() {
        return {
            ICONS,
            userName: '',
            userNo: '',
            version: '1.0.0',
            showAbout: false,
            entries: [
                { text: '我的信件', tip: '信箱与红玫瑰', path: '/forzl', icon: ICONS.letter },
                { text: '成绩曲线', tip: '看小测走势', path: '/hwk/echart', icon: ICONS.chart },
                { text: '作业与成绩', tip: '按日期查看', path: '/hwk/index', icon: ICONS.list },
                { text: '发泄小游戏', tip: '气不顺来一拳', path: '/beat', icon: ICONS.game }
            ]
        };
    },
    computed: {
        displayName() {
            return this.userName || '未登录';
        },
        avatarText() {
            return this.userName ? this.userName.slice(0, 1) : '学';
        },
        subTitle() {
            if (!this.userName) {
                return '登录后可以同步学习记录';
            }
            return this.userNo ? '学号 ' + this.userNo : '今天也要好好的';
        }
    },
    created() {
        try {
            const keys = ['userName', 'uname', 'loginUserName', 'nickname'];
            for (let i = 0; i < keys.length; i++) {
                const v = window.localStorage.getItem(keys[i]);
                if (v && v !== 'null' && v !== 'undefined') {
                    this.userName = String(v);
                    break;
                }
            }
            this.userNo = window.localStorage.getItem('userNo') || '';
        } catch (e) {
            /* 忽略 */
        }
    },
    methods: {
        handleGo(path) {
            if (!path) {
                return;
            }
            this.$router.push({ path });
        }
    }
};
</script>

<style lang="less" scoped>
.mine-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding-bottom: calc(150px + constant(safe-area-inset-bottom));
    padding-bottom: calc(150px + env(safe-area-inset-bottom));
    background: #f4f6fa;
}

/* 头部 */
.mine-hero {
    position: relative;
    padding: 70px 40px 80px;
    text-align: center;
    color: #fff;
    background: var(--blueTheme, #0066b3);
    border-radius: 0 0 44px 44px;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: -150px;
        right: -100px;
        width: 380px;
        height: 380px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.13);
    }
}

.mine-avatar {
    position: relative;
    z-index: 1;
    width: 128px;
    height: 128px;
    margin: 0 auto 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    font-weight: 600;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.36);
}

.mine-name {
    position: relative;
    z-index: 1;
    font-size: 38px;
    font-weight: 600;
    letter-spacing: 1px;
}

.mine-sub {
    position: relative;
    z-index: 1;
    margin-top: 14px;
    font-size: 24px;
    opacity: 0.82;
}

/* 内容 */
.mine-body {
    margin-top: -40px;
    padding: 0 30px;
}

.mine-card {
    margin-bottom: 28px;
    padding: 8px 0;
    background: #fff;
    border-radius: 26px;
    box-shadow: 0 8px 28px rgba(15, 39, 76, 0.06);
    overflow: hidden;
}

.mine-row {
    display: flex;
    align-items: center;
    padding: 30px 32px;
    border-bottom: 1px solid #f2f4f8;

    &:last-child {
        border-bottom: none;
    }
    &:active {
        background: #f7f9fc;
    }
}

.row-ico {
    flex: none;
    width: 64px;
    height: 64px;
    margin-right: 24px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--blueTheme, #0066b3);
    background: var(--lightBlueTheme, #d4eafa);

    svg {
        display: block;
        width: 34px;
        height: 34px;
    }
}

.row-text {
    flex: 1;
    font-size: 28px;
    color: #2b3445;
}

.row-tip {
    font-size: 22px;
    color: #a3abba;
}

.row-arrow {
    margin-left: 12px;
    font-size: 32px;
    color: #c6ccd8;
    line-height: 1;
}

.mine-foot {
    margin: 40px 0 0;
    text-align: center;
    font-size: 20px;
    color: #c2c9d6;
}

/* ---------- 关于弹层（纯 CSS，不依赖组件库） ---------- */
.about-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 80px;
    background: rgba(12, 20, 34, 0.45);
}

.about-box {
    width: 100%;
    padding: 50px 40px 34px;
    text-align: center;
    background: #fff;
    border-radius: 28px;
}

.about-title {
    margin: 0;
    font-size: 34px;
    font-weight: 600;
    color: #22283a;
}

.about-ver {
    margin: 12px 0 26px;
    font-size: 24px;
    color: var(--blueTheme, #0066b3);
}

.about-text {
    margin: 8px 0;
    font-size: 23px;
    color: #7c8698;
}

.about-btn {
    width: 100%;
    height: 84px;
    margin-top: 30px;
    border: none;
    border-radius: 42px;
    font-size: 28px;
    color: #fff;
    background: var(--blueTheme, #0066b3);

    &:active {
        opacity: 0.85;
    }
}
</style>
